import { useActiveUser } from '~/stores/activeUser'

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.meta.public) {
    return
  }

  const activeUser = useActiveUser()
  const { permissions } = activeUser

  const { $auth0, $auth0Ready, $groundcover } = useNuxtApp()
  const { isAuthenticated, checkSession } = $auth0()

  await $auth0Ready()

  if (isAuthenticated.value) {
    return
  }

  if (!import.meta.client) return

  try {
    await checkSession()
  } catch (error) {
    $groundcover.captureException(error as Error, {
      type: 'redirect_to_sign_in',
    })
    return navigateTo('/auth/login')
  }

  if (permissions.includes(PERMISSIONS.writeTeamContent)) return

  $groundcover.sendCustomEvent({
    event: 'Access admin - DENIED',
    attributes: {},
  })

  return navigateTo('/auth/login')
})
